import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { Page } from '../model/Page';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CasteValidityRefLetterApproverListModel } from '../model/CasteValidityRefLetterApproverListModel copy';
import { CasteValidityRefLetterApproverDetailModel } from '../model/CasteValidityRefLetterApproverDetailModel';

@Injectable({
  providedIn: 'root'
})
export class CasteValRefLetterApproverService {

  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }

  fetchCasteValRefLetterApproverList(page: number, size: number, filterText: string, verificationStatus: string) {
    return this.httpClient.get<Page<CasteValidityRefLetterApproverListModel>>(ApiUrls.casteValRefLetterApproverList + 
      `?page=${page}&size=${size}&filterText=${filterText}&verificationStatus=${verificationStatus}`);
  }

  fetchCasteValRefLetterApproverDetail(key: number) {
    return this.httpClient.get<CasteValidityRefLetterApproverDetailModel>(
      ApiUrls.casteValRefLetterApproverDetail.replace('{key}', key.toString()));
  }

  fetchEsignCertificate(key: number) {
    return this.httpClient.get<{status: string, errorMessage: string, data: string | ArrayBuffer}>
    (ApiUrls.casteValRefLetterFetchEsignReceipt.replace('{key}', key.toString()));
  }
  
  submitVerificationDetail(key: number, verificationStatus: string) {
    return this.httpClient.post<{status: string, esignKey: number, url: string, errorMessage: string}>(
      ApiUrls.casteValRefLetterApproverDetail.replace('{key}', 
      key.toString()), {
        verificationStatus: verificationStatus,
    });
  }

  async successToast(msg) {
    await this._snackBar.open(
      msg,
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }

}
